import ApiCore from '../utilities/Core';

// Login API

const url = 'absenceDelete';
const plural = 'absenceDelete';
const single = 'absenceDelete';

export const apiAbsenceDelete = new ApiCore({
    getAll: false,
    getSingle: false,
    post: true,
    put: false,
    patch: false,
    delete: false,
    url: url,
    plural: plural,
    single: single,
});
